import { connectAndForwardRef } from 'util/redux'
import {
  selectChatIdsForAgentsReplyingByConversationId,
  selectChatIdsForAgentsNotingByConversationId,
  selectChatIdsForAgentsTypingReplyByConversationId,
  selectChatIdsForAgentsTypingNoteByConversationId,
} from 'ducks/chat/selectors/rooms'
import { selectCurrentConversationId } from 'ducks/searches/selectors'
import WhoIsTypingTileView from './view'

const select = state => {
  const conversationId = selectCurrentConversationId(state)
  return {
    replyingUserIds: selectChatIdsForAgentsReplyingByConversationId(
      state,
      conversationId
    ),
    notingUserIds: selectChatIdsForAgentsNotingByConversationId(
      state,
      conversationId
    ),
    typingReplyUserIds: selectChatIdsForAgentsTypingReplyByConversationId(
      state,
      conversationId
    ),
    typingNoteUserIds: selectChatIdsForAgentsTypingNoteByConversationId(
      state,
      conversationId
    ),
  }
}

export default connectAndForwardRef(select)(WhoIsTypingTileView)
